<script async setup lang="ts">
const props = defineProps<{
  isTophotel: boolean
  position?: 'left' | 'right'
}>()
</script>

<template>
  <div class="absolute left-2 top-2 z-10 rounded-full bg-white px-2 text-xs font-bold" v-if="props.isTophotel">TOP HOTEL</div>
</template>
